import * as React from 'react';
import { isPastDate } from 'owa-observable-datetime';
import { observer } from 'mobx-react-lite';
import { OwaDate } from 'owa-datetime';

const styles = require('./ColumnPastDayHighlight.scss');

export default observer(function ColumnPastDayHighlight({ date }: { date: OwaDate }) {
    return isPastDate(date) ? <div className={styles.pastHighlight} /> : null;
});
